import type { WithTelemetryProps } from '@tbitop/telemetry';
import { withTelemetry } from '@tbitop/telemetry';
import { Page, PageTitle } from '@tbitop/ui';
import { BugBeetle } from 'phosphor-react';
import type { ErrorInfo, ReactNode } from 'react';
import { Component } from 'react';
import { log } from './log';

type ErrorBoundaryProps = WithTelemetryProps & {
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    log.error('Uncaught error:', error, errorInfo);
    this.props.telemetry?.trackException(error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Page className="flex items-center justify-center">
          <BugBeetle size={100} weight="thin" />
          <div className="ml-5">
            <PageTitle>Sorry</PageTitle>
            <p className="mt-7">Hier ist etwas schief gegangen. Bitte aktualisiere die App und versuche es erneut.</p>
          </div>
        </Page>
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundaryWithTelemetry = withTelemetry(ErrorBoundary);
